module.exports = __webpack_public_path__ + "img/tejarat.fb1e89ed.png";